import { AppRoute } from "app/AppFlow";
import Checkpoint from "../../components/Checkpoint";
import { PageProps } from "./types";
import { DigitalJourneyRoute } from "./constants";

export const DigitalJourneyFlowPage = ({ element, checkpoint, path }: PageProps) => {
  return (
    <Checkpoint checkpoint={checkpoint} path={path as AppRoute & DigitalJourneyRoute}>
      {element}
    </Checkpoint>
  );
};
